document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 80) {
      header.classList.add('scroll-header');
    } else {
      header.classList.remove('scroll-header');
    }
  }, { passive: true });
});

if (document.body.classList.contains('template-product')) {
  const header = document.querySelector('.shopify-section-group-header-group');
  if (header) {
    header.style.display = 'none';
  }
}
